import { Table } from "antd";
import moment from "moment";
import React from "react";
import { AnswerContext } from "../../store/answerStore";

export default function TestSumFNMix(props) {
  const { answerC, dispatchAnswer } = AnswerContext();
  let levelId = JSON.parse(localStorage.getItem("gradeId"));
  levelId =
    levelId === "2"
      ? "L1"
      : levelId === "5"
      ? "L2"
      : levelId === "8"
      ? "L3"
      : levelId === "12"
      ? "L4"
      : "L1";

  const dataSource = () =>
    answerC.answers.map((answer, index) => {
      return {
        key: index,
        que: index + 1,
        score: answer.que_score,
        time: !!answer.que_time
          ? `${Math.ceil(answer.que_time / 1000)}s`
          : "NA",
      };
    });

  const columns = [
    {
      title: "Que No.",
      dataIndex: "que",
      key: "que",
      align: "left",
    },
    {
      title: "Score",
      dataIndex: "score",
      key: "score",
      align: "left",
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      align: "left",
    },
  ];

  return (
    <Table
      tableLayout="fixed"
      dataSource={dataSource()}
      columns={columns}
      pagination={false}
      className="summaryTable"
      scroll={{
        y: 360,
      }}
      title={() => {
        return (
          <div className="summary-header">
            <div className="summary-header-left">
              <p>
                {props.section_name} | {levelId}
              </p>
              <p>Test date:- {moment().format("DD-MMM-YYYY")} </p>
            </div>
            <div className="summary-header-right">
              <p>{props.player_score}</p>
              <p>score</p>
            </div>
          </div>
        );
      }}
    />
  );
}
